import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import Button from '@jetbrains/ring-ui/components/button/button';
import { Content, Header } from '@jetbrains/ring-ui/components/island/island';
import Panel from '@jetbrains/ring-ui/components/panel/panel';
import { zodResolver } from '@hookform/resolvers/zod';
import { Navigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { ToolsFilter } from '@modules/applications/tools-filter';
import { useDialogCancelConfirmation } from '@common/hooks/use-dialog-cancel-confirmation';
import { Dialog } from '@common/dialog/dialog';
import { getApplications } from '@common/store/profiles/selectors';
import { useEvaluatedSettingFilters } from '@common/queries/profile-evaluations';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { tAutoinstalledToolsSchema } from '../../schemas/autoinstalled-tools-schema';
import { getEmptyAutoinstalledTool } from '../../schemas/ctors';
import styles from './profiles-autoinstalled-tools-form.css';
export function AutoinstalledToolsDialogForm({ item, onReject, onSubmit }) {
    var _a, _b;
    const { id: profileId } = useParams();
    const form = useForm({
        defaultValues: item !== null && item !== void 0 ? item : getEmptyAutoinstalledTool(),
        resolver: zodResolver(tAutoinstalledToolsSchema)
    });
    const { formState: { isDirty, isSubmitting, isValid, errors }, handleSubmit, watch, setValue } = form;
    const watchFilters = watch('filters');
    const setFilters = (filters) => {
        setValue('filters', filters, {
            shouldDirty: true,
            shouldValidate: true
        });
    };
    const applications = useSelector(getApplications);
    const { isFetching: isFilterToolsLoading, data: filterTools } = useEvaluatedSettingFilters(applications.rules, watchFilters);
    const canSubmit = isDirty && isValid && !isFilterToolsLoading;
    const submit = async (formData) => {
        onSubmit({ ...formData, tools: filterTools !== null && filterTools !== void 0 ? filterTools : [] });
    };
    const { onCloseAttempt, cancelButtonRef } = useDialogCancelConfirmation(onReject, isDirty);
    if (!profileId) {
        return _jsx(Navigate, { to: "/profiles" });
    }
    return (_jsxs(Dialog, { show: true, autoFocusFirst: false, onCloseAttempt: onCloseAttempt, size: "wide", ...assignTestId('configure-auto-installed-tools-dialog'), children: [_jsx(Header, { children: "Configure Auto-Installed Tools" }), _jsxs(Content, { children: [_jsx(ToolsFilter, { filters: watchFilters, onFiltersChange: setFilters, target: "settings", profileId: profileId, isFilterToolsLoading: isFilterToolsLoading, filterTools: filterTools !== null && filterTools !== void 0 ? filterTools : [], inheritedFilters: applications.rules }), ((_a = errors.filters) === null || _a === void 0 ? void 0 : _a.message) && (_jsx("div", { className: styles.errorMessage, children: ((_b = errors.filters) === null || _b === void 0 ? void 0 : _b.message) && _jsx("p", { children: errors.filters.message }) }))] }), _jsxs(Panel, { children: [_jsx(Button, { primary: true, onClick: handleSubmit(submit), type: "submit", loader: isSubmitting, disabled: !canSubmit, children: "Save" }), _jsx(Button, { ref: cancelButtonRef, onClick: onReject, children: "Cancel" })] })] }));
}
